import React from 'react';
import { type CustomFieldDefinition } from 'src/api/generated';
import CustomFieldDefinitionCard from '../../molecules/custom-fields/custom-field-definition-card';
import { useGetDefinitionFunnels } from 'src/modules/shared/hooks/api/crm/funnels/custom-field-definition-funnels';

interface DefinitionWithFunnelsProps {
  definition: CustomFieldDefinition;
  positionLabel?: number;
  canUpdate: boolean;
  canDelete: boolean;
  onEdit: (id: number) => void;
  onDeleteClick: (def: CustomFieldDefinition) => void;
  funnelsMap: Map<number, string>;
}

export const DefinitionWithFunnels: React.FC<DefinitionWithFunnelsProps> = ({
  definition,
  positionLabel,
  canUpdate,
  canDelete,
  onEdit,
  onDeleteClick,
  funnelsMap,
}) => {
  const { data } = useGetDefinitionFunnels(definition.id, true);
  const funnelIds = data?.funnelIds ?? [];
  const funnelNames =
    funnelIds
      .map((id) => funnelsMap.get(id))
      .filter((name): name is string => Boolean(name)) || [];

  return (
    <CustomFieldDefinitionCard
      key={definition.id}
      definition={definition}
      positionLabel={positionLabel}
      canUpdate={canUpdate}
      canDelete={canDelete}
      onEdit={onEdit}
      onDeleteClick={onDeleteClick}
      funnelNames={funnelNames}
    />
  );
};
